(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@pakhshkit-js/pakhshkit-js"), require("hls.js"));
	else if(typeof define === 'function' && define.amd)
		define("hls", ["pakhshkit-js", "hls.js"], factory);
	else if(typeof exports === 'object')
		exports["hls"] = factory(require("@pakhshkit-js/pakhshkit-js"), require("hls.js"));
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["hls"] = factory(root["pakhshkit"]["core"], root["Hls"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// hls/webpack/universalModuleDefinition